<template>
  <div class="ideaology">
    <div class="textBox2">
      <div class="wrapper" v-scroll-reveal="bottomReveal">
        <h4>Evolutionizing comfort food</h4>
        <h2>
          It is our duty to
          <a class="cursive">Break Tradition</a> and be as progressive
          as we can be
          <a class="cursive">Everyday</a>as chefs.
        </h2>
        <p>
          We believe in putting memory into a fantasy and fantasy into a tasty dish that you eat with your hands. While this core philosophy has never changed over time, it sure has evolved. It’s this evolution of innovation that helps us keep evolving as a restaurant.
        </p>
      </div>
    </div>

    <div class="miniBar">
      <div class="wrapper">
        <span v-scroll-reveal="fastLeftReveal">Ideaology</span>
        <article v-scroll-reveal="fastLeftReveal">we will challenge your senses</article>
      </div>
    </div>

    <div id="fullVideo" v-scroll-reveal="fadeIn">
      <video preload="auto" autoplay loop muted playsinline>
        <source src="../assets/intro.mp4" type="video/mp4" />
      </video>
    </div>

    <div class="textBox3">
      <div class="wrapper" v-scroll-reveal="fastLeftReveal">
        <h4>seasonal emoji menu</h4>
        <h2>Our 25-course menu changes seasonally to get the best out of all of our ingredients.</h2>
        <p>
          Emojis have become a language now. So, we give pencils along with the emoji menu. After each 
          course, guests pen down their reaction next to the emoji. Each emoji is also a hint as to what your next dish is about to be.
        </p>
      </div>
    </div>
    <div class="wrapper bigBox" v-scroll-reveal="scaleUp">
      <div class="marqueeBox">
        <p>💋🌰💥🍋🍚🌶️🍆🍄🍦🐷⛳🍣🌮🍗🌽🍋🌑🦀🍵💐🍩❄️</p>
        <p>💋🌰💥🍋🍚🌶️🍆🍄🍦🐷⛳🍣🌮🍗🌽🍋🌑🦀🍵💐🍩❄️</p>
      </div>
    </div>

    <div class="textBox3">
      <div class="wrapper" v-scroll-reveal="fastLeftReveal">
        <h3>
          The meal continues over three hours, choreographed
          <a
            style="font-weight: 800"
          >like a rock concert, with drama and flair.</a>
        </h3>
        <p>In India, you eat with your hands, that is my culture. The sensuality of the
          eating and touching the dish while experiencing different senses, everything becomes surreal. Every three months, we come up with a new menu.</p>
      </div>
    </div>

    <div class="wrapper bigBox">
      <div id="fullVideo" v-scroll-reveal="scaleUp">
        <video preload="auto" autoplay loop muted playsinline>
          <source src="../assets/gagganCooking.mp4" type="video/mp4" />
        </video>
      </div>
    </div>

    <div class="textBox3">
      <div class="wrapper" v-scroll-reveal="fastLeftReveal">
        <h3>
          Everything we serve to our guests is
          <a style="font-weight: 800">freshly prepared in-house</a>
          with immense thought and care.
        </h3>
        <p>We source ingredients from all over the world. Our ingredients and the menu is seasonally driven to make sure freshness is in everything you consume.</p>
      </div>
    </div>

    <div class="wrapper bigBox" style="padding-bottom: 10vh;" v-scroll-reveal="scaleUp">
      <div id="fullVideo">
        <video preload="auto" autoplay loop muted playsinline>
          <source src="../assets/gagganPlates.mp4" type="video/mp4" />
        </video>
      </div>
    </div>

    <router-link to="/ourStory">
      <nextPage page="Our Story" class="story" />
    </router-link>
  </div>
</template>

<script>
import nextPage from "../components/nextPage.vue";
import VueScrollReveal from "vue-scroll-reveal";

export default {
  name: "Ideaology",
  components: {
    nextPage
  },
  data() {
    return {
      fadeIn: {
         duration: 1000,
      },
      bottomReveal: {
        duration: 1000,
        delay: 500,
        distance: "100px",
        origin: "bottom"
      },
      fadeReveal: {
        duration: 1000,
        delay: 3000
      },
      fastLeftReveal: {
        duration: 1000,
        delay: 1000,
        distance: "50px",
        origin: "left"
      },
      scaleUp: {
        duration: 1500,
        delay: 1000,
        scale: .5
      }
    }
  }
};
</script>

<style src="../styles/main.scss" lang="scss">
</style>